class StudentsInformation extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector("#modal");
    this.modalContent = this.modal.querySelector(".modal-content");
    this.closeModalButton = this.querySelector("#closeModal");
    this.template = this.querySelector("template");
    this.atcButton = document.querySelector("[data-add-to-cart]");
    this.attachedProducts = this.dataset.attachedProductsId || null;
    this.quantitySelector = document.querySelector('select[name="quantity"]');
    this.bundleProduct = document.querySelector("[data-bundle-product]") || null;
    this.buyerWillAttend = true;
  }

  connectedCallback() {
    if (!this.atcButton || !this.quantitySelector) return;

    this.atcButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.getData();
      this.setAttribute("open", "");
    });

    this.closeModalButton.addEventListener("click", () => {
      this.closeModal();
    });
  }

  closeModal() {
    this.modalContent.innerHTML = "";
    this.removeAttribute("open");
    // Add a small delay to ensure modal is fully closed before scrolling
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 300); // Adjust delay if needed based on any CSS transitions
  }

  getData() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const variantId = urlParams.get("variant") || this.dataset.variantId;
    const quantity = Number(this.quantitySelector.value);

    this.renderForm(quantity, variantId);
  }

  renderForm(quantity, variantId) {
    this.modalContent.innerHTML = "";
    const template = this.template.content.cloneNode(true);
    const form = template.getElementById("recipientForm");
    const fieldsContainer = form.querySelector(".form-fields");

    form.addEventListener("submit", (e) => this.addToCart(e));
    form.setAttribute("data-variant-id", variantId);
    form.setAttribute("data-quantity", quantity);

    const bundleProductSelected = this.bundleProduct?.querySelector(
      'input[value="true"]'
    ).checked;

    if (bundleProductSelected || this.attachedProducts) {
      form.querySelector(".shipping-notice").classList.remove("hide");
    }

    if ((this.attachedProducts || bundleProductSelected) && quantity > 1) {
      form
        .querySelectorAll(".multiple-addresses-selector")
        .forEach((f) => f.classList.remove("hide"));
    }

    for (let i = 0; i < quantity; i++) {
      const template = this.template.content.cloneNode(true);
      const fields = template.querySelector(".recipient-fields");

      const title = fields.querySelector("[data-title]");
      title.innerText = `Student ${i + 1}`;

      fields.setAttribute("data-fields-index", i);

      if (i === 0) fields.classList.add("hide");

      fieldsContainer.appendChild(fields);
    }

    this.modalContent.appendChild(form);
    this.handleRadioChange();
    this.handleAddressRadioChange();
    this.initAutocomplete();
  }

  handleRadioChange(e) {
    const quantity = Number(this.quantitySelector.value);
    const bundleProductSelected = this.bundleProduct?.querySelector(
      'input[value="true"]'
    ).checked;

    const selectors = this.querySelectorAll('input[name="attendance"]');
    selectors.forEach((selector) =>
      selector.addEventListener("change", (e) => {
        this.buyerWillAttend = e.target.value === "true";

        if (this.buyerWillAttend) {
          this.querySelector('[data-fields-index="0"]').classList.add("hide");
          this.querySelector(".dob-field").classList.remove("hide");
          if (quantity === 1)
            this.querySelector(".multiple-addresses-selector").classList.add(
              "hide"
            );
        } else {
          this.querySelector('[data-fields-index="0"]').classList.remove(
            "hide"
          );
          this.querySelector(".dob-field").classList.add("hide");
          if (
            quantity === 1 &&
            (this.attachedProducts || bundleProductSelected)
          ) {
            this.querySelector(".multiple-addresses-selector").classList.remove(
              "hide"
            );
          }
        }
      })
    );
  }

  handleAddressRadioChange(e) {
    const diffAddressForm = this.querySelectorAll(".differentAdressForm");

    const selectors = this.querySelectorAll('input[name="shipping"]');
    selectors.forEach((selector) =>
      selector.addEventListener("change", (e) => {
        if (e.target.value === "same_address") {
          diffAddressForm.forEach((f) => f.classList.add("hide"));
        } else {
          diffAddressForm.forEach((f) => f.classList.remove("hide"));
        }
      })
    );
  }

  initAutocomplete() {
    // Select all shipping address inputs on the page
    const addressInputs = this.querySelectorAll(".shippingAddress");

    // Initialize Google Maps Places Autocomplete for each input
    for (let addressInput of addressInputs) {
      const autocomplete = new google.maps.places.Autocomplete(addressInput, {
        types: ["address"],
        componentRestrictions: { country: "us" }, // Adjust as needed
        appendTo: this.modal,
      });

      // Listen for the 'place_changed' event for each input
      autocomplete.addListener("place_changed", function () {
        const place = autocomplete.getPlace();

        if (place.address_components) {
          // Parse the address components and fill the form fields within the same form
          const formFields = {
            street: "",
            city: "",
            state: "",
            zipCode: "",
          };

          place.address_components.forEach((component) => {
            const types = component.types;
            if (types.includes("street_number")) {
              formFields.street = `${component.long_name} ${formFields.street}`;
            }
            if (types.includes("route")) {
              formFields.street += component.long_name;
            }
            if (types.includes("locality")) {
              formFields.city = component.long_name;
            }
            if (types.includes("administrative_area_level_1")) {
              formFields.state = component.short_name;
            }
            if (types.includes("postal_code")) {
              formFields.zipCode = component.long_name;
            }
          });

          // Find the parent form and populate the corresponding fields
          const parentForm = addressInput.closest(".differentAdressForm");
          if (parentForm) {
            parentForm.querySelector(".shippingAddress").value =
              formFields.street;
            parentForm.querySelector(".city").value = formFields.city;
            parentForm.querySelector(".state").value = formFields.state;
            parentForm.querySelector(".zipCode").value = formFields.zipCode;
          }
        }
      });
    }
  }

  validate(form) {
    form.querySelectorAll(".field").forEach((f) => f.classList.remove("error"));
    form.querySelectorAll(".field__error").forEach((f) => (f.innerText = ""));

    const fieldGroups = form.querySelectorAll(".recipient-fields");
    const emailArray = [];
    const quantity = Number(form.dataset.quantity);

    for (let fieldGroup of fieldGroups) {
      if (fieldGroup.classList.contains("hide")) continue;

      const differentAddressForm = fieldGroup.querySelector('.differentAdressForm');

      const email = fieldGroup.querySelector('input[name="email"]');
      const firstName = fieldGroup.querySelector('input[name="first_name"]');
      const lastName = fieldGroup.querySelector('input[name="last_name"]');
      const phoneNumber = fieldGroup.querySelector(
        'input[name="phone_number"]'
      );
      const dob = fieldGroup.querySelector('input[name="dob"]');

      // ✅ NOMBRE: REQUERIDO (MODIFICADO)
      if (!firstName.value) {
        firstName.closest(".field").classList.add("error");
        firstName.closest(".field").querySelector(".field__error").innerText =
          "Please enter a first name";
        return false;
      }

      // ✅ APELLIDO: REQUERIDO (MODIFICADO)
      if (!lastName.value) {
        lastName.closest(".field").classList.add("error");
        lastName.closest(".field").querySelector(".field__error").innerText =
          "Please enter a last name";
        return false;
      }
      
      // ✅ EMAIL: REQUERIDO (MODIFICADO)
      if (!email.value) {
        email.closest(".field").classList.add("error");
        email.closest(".field").querySelector(".field__error").innerText =
          "Please enter an email address";
        return false;
      }

      // EMAIL: VALIDACIÓN DE FORMATO
      if (email.value && !validators.validateEmail(email.value)) {
        email.closest(".field").classList.add("error");
        email.closest(".field").querySelector(".field__error").innerText =
          "Please enter a valid email address";
        return false;
      }

      // EMAIL: Debe ser único si se ingresa.
      if (email.value.trim() && emailArray.includes(email.value.trim())) {
        email.closest(".field").classList.add("error");
        email.closest(".field").querySelector(".field__error").innerText =
          "Email needs to be unique";
        return false;
      }
      if(email.value.trim()) emailArray.push(email.value.trim());

      // ✅ FECHA DE NACIMIENTO (DOB): REQUERIDO (MODIFICADO)
      if (!dob.value) {
        dob.closest(".field").classList.add("error");
        dob.closest(".field").querySelector(".field__error").innerText =
          "Please enter a date of birth";
        return false;
      }
      
      // DOB: VALIDACIÓN DE EDAD
      if (dob.value && !validators.validateDob(dob.value)) {
        dob.closest(".field").classList.add("error");
        dob.closest(".field").querySelector(".field__error").innerText =
          "You need to be at least 21 years old.";
        return false;
      }

      // ✅ TELÉFONO: Requerido si no asiste el comprador O si la cantidad es > 1.
      const requiresPhone = !this.buyerWillAttend || quantity > 1;

      if (requiresPhone && !phoneNumber.value) {
        phoneNumber.closest(".field").classList.add("error");
        phoneNumber.closest(".field").querySelector(".field__error").innerText =
          "Please enter a phone number";
        return false;
      }

      if (phoneNumber.value && !validators.validatePhone(phoneNumber.value)) {
        phoneNumber.closest(".field").classList.add("error");
        phoneNumber.closest(".field").querySelector(".field__error").innerText =
          "Please enter a phone following the format 123-456-7890";
        return false;
      }

      // Address fields (La validación de dirección se mantiene como estaba)
      if (differentAddressForm.classList.contains("hide")) continue;
      
      const shippingAddress = fieldGroup.querySelector(
        'input[name="shippingAddress"]'
      );
      const zipCode = fieldGroup.querySelector('input[name="zipCode"]');
      const city = fieldGroup.querySelector('input[name="city"]');
      const state = fieldGroup.querySelector('input[name="state"]');

      if (!shippingAddress.value) {
        shippingAddress.closest(".field").classList.add("error");
        shippingAddress
          .closest(".field")
          .querySelector(".field__error").innerText =
          "Please enter a valid address";
        return false;
      }

      if (!zipCode.value) {
        zipCode.closest(".field").classList.add("error");
        zipCode.closest(".field").querySelector(".field__error").innerText =
          "Please enter a valid Zip Code";
        return false;
      }

      if (!city.value) {
        city.closest(".field").classList.add("error");
        city.closest(".field").querySelector(".field__error").innerText =
          "Please enter a valid city";
        return false;
      }

      if (!state.value) {
        state.closest(".field").classList.add("error");
        state.closest(".field").querySelector(".field__error").innerText =
          "Please enter a valid state";
        return false;
      }
    }

    return true;
  }

  validateBuyerDob(form) {
    const buyerDob = form.querySelector(".dob-field input");

    buyerDob.closest(".dob-field").classList.remove("error");
    buyerDob.closest(".dob-field").querySelector(".field__error").innerText =
      "";

    if (!buyerDob.value) {
      buyerDob.closest(".dob-field").classList.add("error");
      buyerDob.closest(".dob-field").querySelector(".field__error").innerText =
        "Please enter a valid date";
      return false;
    }

    if (!validators.validateDob(buyerDob.value)) {
      buyerDob.closest(".dob-field").classList.add("error");
      buyerDob.closest(".dob-field").querySelector(".field__error").innerText =
        "You need to be at least 21 years old.";
      return false;
    }

    return true;
  }

  async addToCart(e) {
    e.preventDefault();

    const form = e.target;
    const variant = form.dataset.variantId;
    const fieldGroups = form.querySelectorAll(".recipient-fields");

    if (this.buyerWillAttend && !this.validateBuyerDob(form)) return;

    if (!this.validate(form)) return;

    const formData = {
      items: [],
    };

    // Add Course and props to cart
    fieldGroups.forEach((fieldGroup) => {
      const firstName = fieldGroup.querySelector(
        'input[name="first_name"]'
      ).value;
      const lastName = fieldGroup.querySelector(
        'input[name="last_name"]'
      ).value;
      const email = fieldGroup.querySelector('input[name="email"]').value;
      const dob = fieldGroup.querySelector('input[name="dob"]').value;
      const phone = fieldGroup.querySelector(
        'input[name="phone_number"]'
      ).value;

      let properties = {
        Email: email,
        "First name": firstName,
        "Last name": lastName,
        "Date of birth": dob,
      };

      if (phone) properties["Phone"] = phone;

      if (this.buyerWillAttend && fieldGroup.dataset.fieldsIndex == 0) {
        const buyerDob = form.querySelector(".dob-field input").value;

        properties = {
          Student: "Buyer",
          "Date of birth": buyerDob,
        };
      }

      formData.items.push({
        id: variant,
        quantity: 1,
        properties,
      });
    });

    // Add bundle product and props to cart
    if (this.bundleProduct) {
      const isSelected = this.bundleProduct.querySelector(
        'input[value="true"]'
      ).checked;
      if (isSelected) {
        fieldGroups.forEach((fieldGroup) => {
          const firstName = fieldGroup.querySelector(
            'input[name="first_name"]'
          ).value;
          const lastName = fieldGroup.querySelector(
            'input[name="last_name"]'
          ).value;
          const email = fieldGroup.querySelector('input[name="email"]').value;
          const phone = fieldGroup.querySelector(
            'input[name="phone_number"]'
          ).value;
          const shippingAddress = fieldGroup.querySelector(
            'input[name="shippingAddress"]'
          ).value;
          const zipCode = fieldGroup.querySelector(
            'input[name="zipCode"]'
          ).value;
          const city = fieldGroup.querySelector('input[name="city"]').value;
          const state = fieldGroup.querySelector('input[name="state"]').value;

          let properties = {
            Email: email,
            "First name": firstName,
            "Last name": lastName,
          };

          if (phone) properties["Phone"] = phone;

          properties["Shipping address"] = shippingAddress || 'Buyer';
          if (zipCode) properties["Zip code"] = zipCode;
          if (city) properties["City"] = city;
          if (state) properties["State"] = state;

          if (this.buyerWillAttend && fieldGroup.dataset.fieldsIndex == 0) {
            const buyerDob = form.querySelector(".dob-field input").value;

            properties = {
              Student: "Buyer",
              "Date of birth": buyerDob,
            };
          }

          const variantId = this.bundleProduct.dataset.variantId;
          formData.items.push({
            id: variantId,
            quantity: 1, //Number(this.quantitySelector.value),
            properties,
          });
        });
      }
    }
    
    // Add attached product and props to the cart
    if (this.attachedProducts) {
      fieldGroups.forEach((fieldGroup) => {
        const firstName = fieldGroup.querySelector(
          'input[name="first_name"]'
        ).value;
        const lastName = fieldGroup.querySelector(
          'input[name="last_name"]'
        ).value;
        const email = fieldGroup.querySelector('input[name="email"]').value;
        const phone = fieldGroup.querySelector(
          'input[name="phone_number"]'
        ).value;
        const shippingAddress = fieldGroup.querySelector(
          'input[name="shippingAddress"]'
        ).value;
        const zipCode = fieldGroup.querySelector('input[name="zipCode"]').value;
        const city = fieldGroup.querySelector('input[name="city"]').value;
        const state = fieldGroup.querySelector('input[name="state"]').value;

        let properties = {
          Email: email,
          "First name": firstName,
          "Last name": lastName,
        };

        if (phone) properties["Phone"] = phone;

        properties["Shipping address"] = shippingAddress || 'Buyer';
        if (zipCode) properties["Zip code"] = zipCode;
        if (city) properties["City"] = city;
        if (state) properties["State"] = state;

        if (this.buyerWillAttend && fieldGroup.dataset.fieldsIndex == 0) {
          const buyerDob = form.querySelector(".dob-field input").value;

          properties = {
            Student: "Buyer",
            "Date of birth": buyerDob,
          };
        }

        let attachedProductsArr = this.attachedProducts.split(' , ');
        for (let attachedProduct of attachedProductsArr) {
           formData.items.push({
            id: attachedProduct,
            quantity: 1, //Number(this.quantitySelector.value),
            properties,
          });
        }

      });
    }

    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      this.closeModal();
      document.dispatchEvent(new CustomEvent("cart:build"));

      // [SC] - 8th Oct 2025 - for redirect to direct checkout page on product addition on custom landing template
      if (typeof goToCheckout !== 'function') {
        console.log('goToCheckout not defined');
      } else {
        goToCheckout()
      }

      document.getElementById("HeaderCartTrigger")?.click();
    } catch (error) {
      console.error("Error:", error);
    }
  }
}

customElements.define("students-information", StudentsInformation);

const validators = {
  validateEmail: (email) => {
    const regex = /\S+@\S+\.\S+/;
    return regex.test(email);
  },

  validatePhone: (phone) => {
    const regex = /^(\([0-9]{3}\)\s*|[0-9]{3}\-)[0-9]{3}-[0-9]{4}$/;
    return regex.test(phone);
  },

  validateDob: (dob) => {
    const today = new Date();
    const dobDate = new Date(dob);

    const ageInMilliseconds = today - dobDate;
    const ageInYears = ageInMilliseconds / (365 * 24 * 60 * 60 * 1000);

    return ageInYears >= 21;
  },
};